export default {
	props: {
		apiKey: {
			type: String,
			default: '',
		},
		data: {
			type: String,
			default: '',
		},
		defaultMapCenter: {
			type: Array,
			default: () => [55.76, 37.64],
		},
	},
	data() {
		return {
			mapSettings: {
				apiKey: this.apiKey,
				lang: 'ru_RU',
				coordorder: 'latlong',
				enterprise: false,
				version: '2.1',
			},
			zoom: 13,
			minZoom: 3,
			maxZoom: 18,
			mapControls: [],
			mapOptions: { suppressMapOpenBlock: true, minZoom: 3, maxZoom: 18 },
			center: this.defaultMapCenter,
			mapInstance: null,
			activeMarkerId: null,
			markerDefaultIcon: {
				layout: 'default#image',
				imageHref: '/static/dist/land-v2/img/map-marker-default.svg',
				imageSize: [20, 20],
				imageOffset: [-10, -10],
			},
			markerActiveIcon: {
				layout: 'default#image',
				imageHref: '/static/dist/land-v2/img/map-marker-active.svg',
				imageSize: [48, 52],
				imageOffset: [-24, -50],
			},
			clusterOptions: {
				'object-location-map-cluster': {
					clusterIcons: [
						{
							href: '/static/dist/land-v2/img/map-cluster-icon.svg',
							size: [60, 60],
							offset: [-30, -30],
						},
						{
							href: '/static/dist/land-v2/img/map-cluster-icon.svg',
							size: [70, 70],
							offset: [-35, -35],
						},
						{
							href: '/static/dist/land-v2/img/map-cluster-icon.svg',
							size: [80, 80],
							offset: [-40, -40],
						},
					],
					clusterNumbers: [10, 100],
					zoomMargin: 20,
					clusterIconContentLayout:
						'<div class="object-location-map-cluster">{{ properties.geoObjects.length }}</div>',
				},
			},
			isPopupShow: false,
		}
	},
	computed: {
		objectsArray() {
			return JSON.parse(this.data)
		},
		mapCenter() {
			return this.center
		},
		mapZoom() {
			return this.zoom
		},
		markersList() {
			return this.data ? this.objectsArray : []
		},
		activeMarkerData() {
			if (!this.activeMarkerId) {
				return null
			}
			return (
				this.markersList.find(item => item.s === this.activeMarkerId) ||
				this.markersList.find(
					item => item.cadastralNumber === this.activeMarkerId
				) ||
				this.markersList[this.activeMarkerId - 1]
			)
		},
	},
	mounted() {
		if (this.data) this.setMapCenterAtTheFirstObject()
	},
	methods: {
		initMapHandler(payload) {
			this.mapInstance = payload
		},
		changeZoom(value) {
			this.zoom = value
		},
		changeMapCenter(value) {
			this.center = value
			this.map?.setView(value, this.detailZoom, {
				animation: false,
			})
		},
		// TODO: надо ли не центрировать на маленьких разрешениях, а смещать (< 925px)
		clickMarker(marker) {
			const { s, lat, lng } = marker
			this.activeMarkerId = s
			if (window.innerWidth > 925) this.changeMapCenter([lat, lng])
		},
		clickMarkerOnDetail(marker, index) {
			const { lat, lng } = marker
			this.activeMarkerId = index
			if (window.innerWidth > 925) this.changeMapCenter([lat, lng])
		},
		clickMarkerCadastral(marker) {
			const { cadastralNumber, lat, lng } = marker
			this.activeMarkerId = cadastralNumber
			if (window.innerWidth > 925) this.changeMapCenter([lat, lng])
		},
		clearActiveMarker() {
			this.activeMarkerId = null
			if (this.markerGroup?.length) {
				this.closePopup()
			}
		},
		setCurrentMapCenter() {
			this.changeMapCenter(this.mapInstance.getCenter())
		},
		setMapCenterAtTheFirstObject() {
			this.changeMapCenter([this.objectsArray[0].lat, this.objectsArray[0].lng])
		},
		setMapCenterAtTheActiveObject() {
			this.setCurrentMapCenter()
			const coords = [this.activeMarkerData?.lat, this.activeMarkerData?.lng]
			setTimeout(() => {
				if (this.activeMarkerData && coords !== this.mapInstance.getCenter()) {
					this.changeMapCenter(coords)
				} else {
					this.setMapCenterAtTheFirstObject()
					// this.activeMarkerId = this.data.features[0].id; // TODO: надо ли делать активным элемент, если да, то зум?
				}
			}, 100)
		},
		increaseZoom() {
			this.changeZoom(this.mapInstance.getZoom())
			setTimeout(() => {
				if (this.zoom < this.maxZoom) {
					this.zoom++
					this.map?.setZoom(this.zoom)
				}
			}, 100)
		},
		decreaseZoom() {
			this.changeZoom(this.mapInstance.getZoom())
			setTimeout(() => {
				if (this.zoom > this.minZoom) {
					this.zoom--
					this.map?.setZoom(this.zoom)
				}
			}, 100)
		},
	},
}
